import React from 'react';

export default function useRenderedAt(): string | undefined {
  const renderedAt = React.useRef<string | undefined>();

  React.useEffect(() => {
    renderedAt.current = new Date().toISOString();
  }, []);

  return renderedAt.current;
}
